import React, { useState } from "react";
import { Button, Field, ErrorMessage } from "./components.jsx";
import { money } from "../shared/catalog.js";
import { paymentLabel } from "../shared/deliveries.js";

export function PaymentForm({ order, onUpdate, disabled = false }) {
  const [received, setReceived] = useState(String(order.received / 100)),
    [method, setMethod] = useState(order.paymentMethod),
    [reference, setReference] = useState(order.paymentReference || ""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [saved, setSaved] = useState(false);
  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    setSaved(false);
    try {
      await onUpdate({
        action: "payment",
        received: Math.round(Number(received) * 100),
        method,
        reference,
      });
      setSaved(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <form className="payment-record" onSubmit={submit}>
      <div className="money-summary">
        <span>
          Order total<strong>{money(order.total)}</strong>
        </span>
        <span>
          Money in<strong>{money(order.received)}</strong>
        </span>
        <span>
          {order.received > order.total ? "Extra received" : "Remaining"}
          <strong>{money(Math.abs(order.total - order.received))}</strong>
        </span>
      </div>
      <div className="form-row">
        <Field label="Amount received ($)">
          <input
            type="number"
            step="0.01"
            min="0"
            max="10000"
            required
            value={received}
            onChange={(e) => {
              setReceived(e.target.value);
              setSaved(false);
            }}
          />
        </Field>
        <Field label="Payment method">
          <select
            value={method}
            onChange={(e) => {
              setMethod(e.target.value);
              setSaved(false);
            }}
          >
            {["cash", "card", "venmo", "other"].map((m) => (
              <option value={m} key={m}>
                {paymentLabel(m)}
              </option>
            ))}
          </select>
        </Field>
      </div>
      <Field label="Payment reference or note (optional)">
        <input
          maxLength={160}
          value={reference}
          onChange={(e) => {
            setReference(e.target.value);
            setSaved(false);
          }}
          placeholder="Envelope checked, transaction reference…"
        />
      </Field>
      <ErrorMessage>{error}</ErrorMessage>
      <Button
        className="button-outline button-small"
        disabled={disabled || busy}
      >
        {busy ? "Saving…" : "Save money received"}
      </Button>
      {saved && (
        <span className="payment-saved" role="status">
          Payment recorded.
        </span>
      )}
      <p className="fine-print">
        This records money already received. It does not charge a card or send a
        Venmo request.
      </p>
    </form>
  );
}
